import React, { useState, useEffect, useRef } from 'react';
import propTypes from 'prop-types';
import _shuffle from 'lodash/shuffle.js';
import { VIEWS } from './AiExperience.jsx';
import { LoadingScreen } from '_ui-core-js/React/components/LoadingScreen.jsx';

export function InstagramFeedGenerationScreen(props) {

  const { data, state } = props;
  const instagramErrorResponseRef = useRef(false);
  const instagramImageFeedRef = useRef();
  const [instagramResponded, setInstagramResponded] = useState(false);

  function proceedToNextScreen() {
    if (!instagramErrorResponseRef.current) {
      if (instagramImageFeedRef.current) { // instagram account has 9 or more images
        state.setInstagramImageFeed(instagramImageFeedRef.current);
        state.setActiveView(VIEWS.instagramColorPaletteSelection.name);  
      }
      else { // instagram account does not has 9 or more images
        state.setError(data.imagesErrorMsg);
        state.setLoggedIn(false);
        state.setActiveView(VIEWS.colorPaletteSelection.name); 
      }
    }
    else if (instagramErrorResponseRef.current) { // network error
      state.setLoggedIn(false);
      state.setInstagramCode(undefined);
      state.setError(data.networkErrorMsg);
      state.setActiveView(VIEWS.login.name);  
    }
  };

  function formatImageData(imageUrls) {
    const images = _shuffle(imageUrls);
    images.length = 9;
    return _shuffle(images).map((imageUrl, index) => ({ url: imageUrl, alt: 'instagram feed image', id: `instagram-image-${index}`}));
  };

  useEffect(async () => {
    if (state.loggedIn && state.instagramCode) {
      try {
        const { images } = await state.getInstagramPosts(state.instagramCode)
        if (images.length >= 9) {
          instagramImageFeedRef.current = formatImageData(images);
        } 
      } catch (error) {
        instagramErrorResponseRef.current = true;
      } finally {
        setInstagramResponded(true);
      }
    }
    if (state.instagramAuthError) {
      instagramErrorResponseRef.current = true;
      setInstagramResponded(true);
    }
  }, []);

  return (
    <LoadingScreen 
    text={data.loadingText}
    videoUrl={data.videoUrl} 
    loopVideo={true} 
    onLoadingCompletionCallback={proceedToNextScreen}
    loadingConditionsComplete={instagramResponded}
    />
  )
};

InstagramFeedGenerationScreen.propTypes = {
  block: propTypes.string.isRequired,
  state: propTypes.object.isRequired,
  data: propTypes.object.isRequired
};
